import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 1",
  viewBox: "0 0 82.57 46.21"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M66.05 0H42.93v46.21h13.2V32.98h9.92c9.11 0 16.52-7.39 16.52-16.5 0-9.13-7.41-16.49-16.52-16.49m0 19.8h-9.92v-6.6h9.92c1.81 0 3.31 1.46 3.31 3.3 0 1.81-1.5 3.3-3.31 3.3",
      style: {"fill":"#eb2d2e"}
    }, null, -1),
    _createElementVNode("path", {
      d: "M0 0v13.19h9.89V46.2h13.24l2.49-8.23h14.84l2.47 8.23V0M29.54 24.76l3.49-11.56 3.47 11.56h-6.96Z",
      style: {"fill":"#bfd33b"}
    }, null, -1),
    _createElementVNode("path", {
      d: "M9.89 46.21h13.24V13.2h9.91V0h-9.91",
      style: {"fill-rule":"evenodd","fill":"#72bc4a"}
    }, null, -1),
    _createElementVNode("path", {
      d: "M42.93 46.21h13.2L42.93 0",
      style: {"fill":"#c92c32","fill-rule":"evenodd"}
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "TP-logo"}) } }